// Viral footer + signup attribution.
//
// Public pages carry a "Made with Tagdada" footer that links to the landing
// page with the host's referral code (?ref=) plus UTM params. We persist that
// attribution so a visitor who explores the landing first and signs up later
// still credits the host who shared the calendar.
const KEY = 'tagdada_attribution';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.ts || Date.now() - data.ts > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

// Persist ref/utm from the current location (last-touch attribution).
export function captureAttribution(search) {
  try {
    const params = new URLSearchParams(search ?? window.location.search);
    const ref = (params.get('ref') || '').trim();
    const utm = {};
    UTM_KEYS.forEach((k) => { const v = params.get(k); if (v) utm[k] = v; });
    if (!ref && Object.keys(utm).length === 0) return;
    localStorage.setItem(KEY, JSON.stringify({ ref, utm, ts: Date.now() }));
  } catch { /* ignore */ }
}

export function getStoredRef() {
  return read()?.ref || '';
}

export function clearAttribution() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

// Build the attributed "Powered by" landing link.
export function viralFooterLink(ref, medium = 'booking_footer') {
  const params = new URLSearchParams();
  if (ref) params.set('ref', ref);
  params.set('utm_source', 'tagdada');
  params.set('utm_medium', medium);
  params.set('utm_campaign', 'viral_footer');
  return `/?${params.toString()}`;
}
